var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _mask, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKoscherSertified = function SvgKoscherSertified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__a)",
    stroke: "url(#KoscherSertified_svg__b)",
    strokeMiterlimit: 10,
    strokeWidth: 0.148,
    d: "M9.379 21.452c-.05-6.72 5.559-12.378 12.526-12.279 6.72.099 12.13 5.682 12.08 12.477-.073 6.769-5.657 12.18-12.525 12.13-6.646-.074-12.13-5.658-12.057-12.328zm24.384.025c0-6.696-5.435-12.106-12.155-12.082-6.745 0-12.106 5.535-12.056 12.23.049 6.596 5.509 11.982 12.18 11.958 6.596 0 12.031-5.485 12.007-12.106z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__c)",
    stroke: "url(#KoscherSertified_svg__d)",
    strokeWidth: 0.528,
    d: "m36.032 22.726-.05.028v-.092h.013zm2.86-.247h-.069v-.07l.023-.013z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__e)",
    stroke: "url(#KoscherSertified_svg__f)",
    strokeWidth: 0.528,
    d: "M12.374 34.848v1.446l-.017-.02c-.032-.041-.06-.111-.048-.299l.037-.642zm0-.47v.093a1.4 1.4 0 0 0-.124-.468 1.2 1.2 0 0 0-.202-.3q.216.157.439.304l-.113-.056zm-.95-1.392-.093.136-.193-.165-.169.225c-.317.423-.635.829-.97 1.249l-.046-.034q.561-.726 1.116-1.451.557-.728 1.12-1.456l.036.029-.14.174c-.137.172-.263.338-.39.504l-.036.048c-.139.182-.279.364-.437.559zm2.645.234a.9.9 0 0 0-.099-.274.7.7 0 0 1 .169.375c.02.172-.03.371-.168.595a.82.82 0 0 1-.46.363.87.87 0 0 1-.52-.03.9.9 0 0 0 .373.002.9.9 0 0 0 .553-.389.84.84 0 0 0 .152-.642Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__g)",
    stroke: "url(#KoscherSertified_svg__h)",
    strokeWidth: 0.528,
    d: "M31.872 12.349c.067-.38.115-.76.159-1.116l.016-.128c.045-.3-.028-.566-.18-.79q.232.196.48.375v.001l.023.015h-.257l-.023.239q-.049.5-.11 1.027-.046.42-.091.85a.2.2 0 0 1-.044-.055c-.006-.014-.015-.037-.013-.102.002-.07.015-.166.04-.316Zm0 0v.001l-.26-.046m.26.045v-.001l-.26-.044m0 0c-.082.49-.079.592.245.836l-.393-2.886c.247.222.37.494.32.815l-.015.132c-.045.356-.091.73-.157 1.103Zm-.738-2.862-.126.141c-.209.234-.418.46-.628.69q-.227.247-.455.498l-.032-.031c.422-.458.835-.915 1.248-1.37v-.001q.613-.68 1.237-1.358l.04.038-.14.14a21 21 0 0 0-.976 1.05l-.173.199zm2.985.427a1 1 0 0 0-.042-.175c.144.276.097.613-.138.937a.8.8 0 0 1-.832.254q.105.01.212-.005a.98.98 0 0 0 .609-.358l.001-.002a.83.83 0 0 0 .19-.651Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__i)",
    stroke: "url(#KoscherSertified_svg__j)",
    strokeWidth: 0.528,
    d: "M20.467 35.228v-.007h.108l-.093.004v3.464h.264v.18h-.28v-3.641Zm2.087.105a2 2 0 0 0-.34-.111h.025c.543.041.872.398 1.075.96.2.579.18 1.158-.024 1.75q-.12.308-.306.504a1.33 1.33 0 0 0 .296-.67l.001-.006c.051-.382.077-.795.051-1.212-.028-.475-.23-.989-.778-1.215Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__k)",
    stroke: "url(#KoscherSertified_svg__l)",
    strokeWidth: 0.528,
    d: "M14.925 36.373v-.006c0-.78.407-1.453.955-1.803a1.64 1.64 0 0 0-.49.594 3.4 3.4 0 0 0-.373 1.146c-.061.387.016.748.194 1.05a1.7 1.7 0 0 1-.286-.98Zm3.63-.344h-.05c-.018-.391-.1-.722-.262-.991.208.285.328.637.329 1.027-.024.489-.178 1.019-.479 1.42-.126.169-.28.316-.462.43a2 2 0 0 0 .26-.23h.001c.442-.47.61-1.022.64-1.37z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__m)",
    stroke: "url(#KoscherSertified_svg__n)",
    strokeWidth: 0.528,
    d: "M13.35 9.35c-.451-.376-.758-.977-.774-1.69q.002-.132.024-.26c-.043.401.058.838.236 1.215.126.269.3.527.513.734Zm1.8-3.15a1.5 1.5 0 0 0-1.004-.24q.119-.015.241-.016c.453 0 .918.234 1.275.624s.585.914.585 1.459q0 .235-.063.454.029-.162.024-.335c-.002-.8-.364-1.5-1.057-1.945Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__o)",
    stroke: "url(#KoscherSertified_svg__p)",
    strokeWidth: 0.528,
    d: "M26.134 8.874c.517-1.1 1.035-2.2 1.571-3.317l.053.025-.09.193c-.173.371-.345.739-.54 1.13l-.12.24.24.117.537.26a37 37 0 0 0-.536-.245l-.236-.106-.11.234c-.197.417-.393.81-.616 1.255l-.116.232z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__q)",
    stroke: "url(#KoscherSertified_svg__r)",
    strokeWidth: 0.528,
    d: "M19.435 4.584c.261.06.477.256.59.538q-.001.002-.013-.008a.4.4 0 0 1-.087-.135l-.003-.006a.8.8 0 0 0-.33-.316 1 1 0 0 0-.157-.073Zm-1.87 1.1c.083.342.37.552.71.584q.319.036.632.062h.002c.21.02.417.037.622.062h.003c.32.034.534.111.68.219.142.103.242.251.304.476a.77.77 0 0 1-.01.454.9.9 0 0 0 .007-.344.83.83 0 0 0-.26-.493.95.95 0 0 0-.473-.217l-.006-.001c-.242-.038-.488-.064-.727-.088h-.003a13 13 0 0 1-.703-.085c-.288-.045-.471-.134-.586-.244a.68.68 0 0 1-.192-.384Zm.276 2.09c.096.205.249.355.432.456a1 1 0 0 1-.226-.133.9.9 0 0 1-.31-.449h.02l.008.006a.4.4 0 0 1 .075.119Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__s)",
    stroke: "url(#KoscherSertified_svg__t)",
    strokeWidth: 0.528,
    d: "m22.47 4.382.043.001-.076.588c-.037.284-.075.569-.112.866l-.028.23-.048-.007v.309c-.084.57-.169 1.122-.253 1.672l-.05-.009q.13-.911.26-1.816.134-.914.264-1.834Zm2.48 2.315.028-.2.011.001.035-.275c.036-.291.079-.566.122-.84l.008-.048q.042-.261.08-.528l.024.003.02.002c-.174 1.214-.347 2.426-.52 3.62l-.036-.004c.005-.046.015-.108.029-.195v-.002q.056-.378.1-.764l.005-.043q.044-.364.093-.727Zm-.305 1.715h.002z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__u)",
    stroke: "url(#KoscherSertified_svg__v)",
    strokeWidth: 0.528,
    d: "M10.182 12.186c.218.219.452.437.7.665l-.039.041-.006.007-.002.003-1.278-1.31-1.284-1.316q.26.252.522.5l.01.01c.245.231.49.464.734.708l.451.451v-.081a1 1 0 0 0 .04.093c.038.074.085.144.127.2l.011.016zm.116-1.607-.21-.043.112.019q.761.129 1.51.247l1.07.174-.004.002c-.053.027-.145.043-.38-.004h-.005c-.692-.125-1.38-.248-2.093-.395Zm-.268-1.501q-.015.303-.027.614a20 20 0 0 1 .03-.67zm-.04 1.982v-.103l.013.012-.013.181v-.089Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__w)",
    stroke: "url(#KoscherSertified_svg__x)",
    strokeWidth: 0.528,
    d: "m8.517 30.096-.063-.1.037.052c.125.178.257.364.4.542l-.096-.115-.008-.01a3 3 0 0 1-.27-.37Zm.944 1.048a2 2 0 0 1-.122-.095.83.83 0 0 0 .486.145c.243-.005.472-.112.666-.276.185-.157.33-.346.366-.584a.8.8 0 0 0 .005-.172c.067.257-.051.586-.338.819l-.002.002c-.39.324-.773.363-1.06.16Zm.218-2.897.164.248a.4.4 0 0 0-.206-.072c-.153-.008-.282.075-.353.122l-.007.005-.007.005c-.144.11-.293.216-.45.328l-.04.027q-.146.104-.298.216l-.022-.029q.602-.424 1.219-.85Zm-1.81 1.266.285-.2v.2h-.285Zm-1.22.857q.484-.337.968-.679l.02.028-.08.053a9 9 0 0 0-.79.568.6.6 0 0 1-.096.067z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__y)",
    stroke: "url(#KoscherSertified_svg__z)",
    strokeWidth: 0.528,
    d: "M28.259 36.404a27 27 0 0 0-.356-1.06q-.152-.43-.286-.842a7 7 0 0 0-.191-.54l.057-.024c.02.047.042.113.076.21l.25.738c.196.57.39 1.136.561 1.718.113.417-.024.77-.372 1.032q.121-.112.203-.251c.17-.29.171-.626.058-.981Zm0 0v.001l-.252.078m.252-.08-.252.08m0 0c.197.618-.05 1.013-.717 1.26l-.197-3.904c.099.248.197.495.271.742.09.279.19.563.29.85.121.348.244.7.353 1.052Zm-2.984-1q-.097-.282-.208-.58l.015-.005.012-.005.57 1.58v.002l.059.165c.08.223.166.467.27.694l.002.004c.155.325.376.57.675.688q.056.022.113.037a.8.8 0 0 1-.415-.17q-.214-.17-.363-.505v-.001c-.12-.263-.222-.532-.324-.81l-.052-.143q-.123-.344-.261-.688zm2.428-1.61v.002z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__A)",
    stroke: "url(#KoscherSertified_svg__B)",
    strokeWidth: 0.528,
    d: "M7.252 19.202h.002l-.008.061a1 1 0 0 0-.064-.061h.07Zm-.03 2.307.104-.172.077.035v.118a.8.8 0 0 0-.181.019Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__C)",
    stroke: "url(#KoscherSertified_svg__D)",
    strokeWidth: 0.528,
    d: "m29.458 33.784.002.007a2.84 2.84 0 0 0 1.223 1.525l.007.004c.251.145.53.203.809.186-.374.036-.778-.082-1.18-.4h-.002c-.632-.493-1.024-1.058-.96-1.82v-.006q.014-.207.1-.422a1.53 1.53 0 0 0 0 .926Zm3.453-.353.025-.011q.118.331.09.62a1 1 0 0 1-.026.167c.034-.247.003-.51-.089-.776Zm-2.446-1.608a1.3 1.3 0 0 1 1.126.033l-.024.036-.032-.012a1.5 1.5 0 0 0-.87-.112 1.3 1.3 0 0 0-.2.055Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__E)",
    stroke: "url(#KoscherSertified_svg__F)",
    strokeWidth: 0.528,
    d: "m32.706 29.25.021-.032.202.13c.963.619 1.905 1.238 2.865 1.877l-.016.026A378 378 0 0 1 33.9 30.03l-1.007-.657z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__G)",
    stroke: "url(#KoscherSertified_svg__H)",
    strokeWidth: 0.528,
    d: "m5.817 18.96-.094-.075z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "KoscherSertified_svg__K",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.834 20.105s.024.05.05.074c.197.396.42.766.642 1.162-.272.074-.42 0-.52-.223-.073-.173-.197-.32-.271-.47 0-.024-.025-.049-.05-.073-.296-.52-.568-1.038-.889-1.606h1.359c.05 0 .074.123.123.197a.2.2 0 0 1-.049.1c-.272 0-.543.024-.84.049.173.296.321.543.47.79z"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__I)",
    d: "M4.834 20.105s.024.05.05.074c.197.396.42.766.642 1.162-.272.074-.42 0-.52-.223-.073-.173-.197-.32-.271-.47 0-.024-.025-.049-.05-.073-.296-.52-.568-1.038-.889-1.606h1.359c.05 0 .074.123.123.197a.2.2 0 0 1-.049.1c-.272 0-.543.024-.84.049.173.296.321.543.47.79z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__J)",
    d: "M4.834 20.105v-.528h-.855l.382.765zm.05.074.472-.236-.038-.077-.061-.06zm.642 1.162.139.51.653-.179-.332-.59zm-.52-.223-.485.209.003.006zm-.271-.47h-.528v.126l.055.111zm-.05-.073-.458.262.035.061.05.05zm-.889-1.606v-.529H2.89l.446.789zm1.482.197h.529v-.16l-.089-.133zm-.049.1v.528h.219l.155-.155zm-.84.049-.044-.527-.834.07.422.723zm.47.79v.529h.933l-.48-.8zm-.025 0-.473.237.001.001.001.002q0 .002.003.005l.007.014.023.041a.8.8 0 0 0 .114.148l.747-.747c.022.022.035.04.038.044l.007.011.001.002.001.002.001.001.001.002zm-.423.31c.205.411.441.806.654 1.185l.921-.519c-.232-.412-.44-.758-.63-1.138zm.976.416c-.037.01-.049.009-.043.009a.218.218 0 0 1 .147.072c.01.012.009.014-.001-.008l-.966.429c.078.176.214.38.463.49.24.108.485.08.678.027zm.105.08a2 2 0 0 0-.176-.322c-.059-.091-.087-.134-.108-.176l-.946.472c.053.106.124.211.164.274.048.076.077.124.095.167zm-.229-.262a.6.6 0 0 0-.12-.354c-.037-.049-.078-.089-.084-.094l-.747.747c.02.02.002.004-.015-.02a.483.483 0 0 1-.09-.28zm-.119-.336c-.145-.255-.285-.51-.43-.776-.145-.265-.295-.54-.458-.828l-.92.52c.158.28.305.548.45.815q.216.397.44.793zm-1.348-.816h1.359V18.44H3.796zm1.359 0a.49.49 0 0 1-.382-.18c-.031-.04-.044-.072-.036-.056l.01.021.017.042c.014.03.039.081.075.136l.88-.587c.01.017.014.026.007.012l-.01-.025-.02-.041c-.01-.024-.041-.091-.093-.157a.57.57 0 0 0-.448-.222zm-.405-.33a.5.5 0 0 1 .04-.187.3.3 0 0 1 .065-.088l.748.747a.7.7 0 0 0 .133-.187.65.65 0 0 0 .07-.286zm.48-.43c-.3 0-.597.027-.885.051l.088 1.053c.305-.025.551-.047.796-.047zm-1.297.844c.174.3.324.55.472.796l.907-.544a70 70 0 0 1-.466-.784zm.926-.004h-.025v1.057h.025z",
    mask: "url(#KoscherSertified_svg__K)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__L)",
    stroke: "url(#KoscherSertified_svg__M)",
    strokeWidth: 0.528,
    d: "M20.508 22.74q.094-.263.185-.511.114-.287.217-.566c.117-.314.232-.62.37-.927l.004-.008.003-.008a.84.84 0 0 0 .061-.39.7.7 0 0 0-.181-.393c-.235-.279-.338-.53-.352-.75-.013-.216.056-.437.233-.668q.035-.041.053-.06l.018.008c.14.07.291.125.433.172l.148.048q.134.043.262.088l.013.005a.52.52 0 0 1 .257.157c.052.062.09.147.1.267v.785a.8.8 0 0 0-.572.258c-.163.175-.244.413-.305.62q-.222.62-.453 1.237-.234.62-.459 1.252l-.001.004-.037.111-.037.111-.077.23.221.096c.41.18.783.272 1.128.18.354-.094.61-.36.834-.728q.326-.526.652-1.057.528-.861 1.076-1.732l.163-.259-.28-.124c-.108-.048-.21-.096-.315-.146h-.002q-.154-.075-.322-.15a.63.63 0 0 1-.288-.232.5.5 0 0 1-.054-.332c.04-.282.136-.549.246-.838l.012-.001h.014c.132.033.262.078.4.128l.108.041q.159.06.33.12c.224.078.322.152.377.232.059.085.1.22.111.486 0 .455-.092.877-.312 1.275a318 318 0 0 0-2.176 4.005l-.002.003c-.145.28-.29.425-.448.503-.16.08-.375.108-.697.073a5 5 0 0 0-.7-.02l-.233.008c-.14.006-.272.01-.405.01-.146 0-.21-.026-.241-.05-.027-.02-.065-.063-.094-.186l-.062-.304a84 84 0 0 1-.627-3.29c-.04-.244-.001-.548.07-.832l.004-.017.002-.018c.03-.265.002-.52-.209-.767-.202-.246-.283-.477-.28-.692.002-.21.083-.436.265-.678l.008-.003.179.06c.294.095.554.18.817.311a.5.5 0 0 1 .132.115c.048.06.068.109.07.13l.262-.037-.262.035c.022.164.023.338.017.528l-.013.337c-.262.07-.481.181-.64.368-.2.235-.267.543-.28.897v.002c-.026.899.214 1.692.734 2.498l.283.438.186-.487q.19-.501.358-.972Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__N)",
    stroke: "url(#KoscherSertified_svg__O)",
    strokeWidth: 0.528,
    d: "m26.327 22.557-.006.003c-.064-.514.06-.956.272-1.42l.002-.003c.097-.22.198-.458.213-.712.017-.272-.063-.536-.267-.812l-.005-.007c-.127-.16-.156-.343-.098-.554.043-.157.135-.328.273-.504q.138.12.306.177c.198.069.413.073.596.073h1.754c.307 0 .501.052.642.145.14.092.26.248.373.53l.002.004c.323.762.374 1.58.35 2.46v.006c0 1.03-.192 2.034-.575 2.99-.105.263-.148.317-.178.338-.03.02-.09.04-.367.04h-3.36c-.12 0-.196-.004-.246-.013.002-.05.013-.124.036-.24l.001-.006c.05-.286.089-.485.135-.629.046-.141.089-.2.127-.23.04-.033.107-.065.259-.084s.358-.024.652-.024h.006c.614 0 1.265 0 1.892-.05h.002c.333-.029.628-.147.85-.36a1.3 1.3 0 0 0 .379-.843c.05-.558.05-1.14 0-1.722-.016-.302-.126-.56-.336-.739-.207-.176-.479-.248-.767-.248-.287 0-.573.012-.855.024h-.012c-.288.013-.573.025-.863.025a.673.673 0 0 0-.682.602l-.002.017v.016c0 .163.047.317.158.44.106.117.247.18.39.212.499.132.83.751.652 1.313l-.01.003a.12.12 0 0 1-.091-.016 1.3 1.3 0 0 1-.307-.264l-.01-.01a.7.7 0 0 0-.501-.253.84.84 0 0 0-.481.156 5 5 0 0 1-.295.165zm-.318 2.783v-.001Zm2.026-2.57h-.002z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__P)",
    stroke: "url(#KoscherSertified_svg__Q)",
    strokeWidth: 0.528,
    d: "M12.225 18.5c1.164.233 2.31.228 3.423.223l.478-.001c.168 0 .211.038.22.048.012.013.046.066.035.24v.002c-.012.227-.036.461-.061.703v.003c-.025.239-.05.484-.063.725v.002l.264.014m-4.296-1.96 3.933 6.174m-3.933-6.174c-.059.26-.11.484-.11.7v.014c-.01.176.03.286.086.356s.15.131.314.16h.003c.385.073.763.12 1.137.12h.018c.664.046 1.328.07 1.956.093l.02.001.58-.58-.19.88a17 17 0 0 1-.1.425l-.006.02q-.048.194-.09.377a3.4 3.4 0 0 0-.095.728v.01a43 43 0 0 0-.011 2.369q.007.5.01 1M12.225 18.5l3.522 6.674m.774-4.714q-.075 1.148-.074 2.297c0 .643 0 1.285-.025 1.927m.1-4.224c.012-.235.036-.476.06-.717.026-.24.05-.482.063-.716zm-.1 4.224-.264-.011m.264.011-.264-.01m.264.01c-.024.569-.296.766-.89.766m.626-.777c-.01.248-.072.351-.136.404a.53.53 0 0 1-.275.097m-.214.276.074-.074.112-.112.002.003.013.03a.2.2 0 0 1 .014.08v-.203m-.215.276v-.264q.124 0 .214-.012m-.214.276s-.05-.05-.05-.074q-.001-.591-.01-1.19a43 43 0 0 1 .01-2.392l.264 3.38"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KoscherSertified_svg__R)",
    stroke: "url(#KoscherSertified_svg__S)",
    strokeWidth: 0.528,
    d: "M40.526 21.498c0-10.572-8.593-19.164-19.164-19.164S2.197 10.926 2.197 21.498s8.593 19.164 19.165 19.164 19.164-8.592 19.164-19.164Zm-39.9 0C.626 10.058 9.92.762 21.362.762c11.44 0 20.735 9.295 20.735 20.736s-9.294 20.736-20.735 20.736C9.92 42.234.626 32.939.626 21.498Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__a",
    x1: 15.53,
    x2: 31.936,
    y1: 9.172,
    y2: 33.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__b",
    x1: 15.53,
    x2: 31.936,
    y1: 9.172,
    y2: 33.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__c",
    x1: 35.618,
    x2: 39.748,
    y1: 18.42,
    y2: 23.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__d",
    x1: 35.618,
    x2: 39.748,
    y1: 18.42,
    y2: 23.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__e",
    x1: 10.783,
    x2: 14.703,
    y1: 31.117,
    y2: 36.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__f",
    x1: 10.783,
    x2: 14.703,
    y1: 31.117,
    y2: 36.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__g",
    x1: 30.489,
    x2: 34.462,
    y1: 7.635,
    y2: 12.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__h",
    x1: 30.489,
    x2: 34.462,
    y1: 7.635,
    y2: 12.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__i",
    x1: 21.063,
    x2: 24.015,
    y1: 34.934,
    y2: 38.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__j",
    x1: 21.063,
    x2: 24.015,
    y1: 34.934,
    y2: 38.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__k",
    x1: 15.704,
    x2: 18.669,
    y1: 34.045,
    y2: 38.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__l",
    x1: 15.704,
    x2: 18.669,
    y1: 34.045,
    y2: 38.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__m",
    x1: 13.362,
    x2: 16.298,
    y1: 5.68,
    y2: 9.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__n",
    x1: 13.362,
    x2: 16.298,
    y1: 5.68,
    y2: 9.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__o",
    x1: 26.937,
    x2: 30.511,
    y1: 5.195,
    y2: 9.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__p",
    x1: 26.937,
    x2: 30.511,
    y1: 5.195,
    y2: 9.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__q",
    x1: 18.165,
    x2: 21.233,
    y1: 4.301,
    y2: 8.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__r",
    x1: 18.165,
    x2: 21.233,
    y1: 4.301,
    y2: 8.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__s",
    x1: 22.631,
    x2: 25.859,
    y1: 4.115,
    y2: 8.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__t",
    x1: 22.631,
    x2: 25.859,
    y1: 4.115,
    y2: 8.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__u",
    x1: 9.238,
    x2: 12.858,
    y1: 7.873,
    y2: 13.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__v",
    x1: 9.238,
    x2: 12.858,
    y1: 7.873,
    y2: 13.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__w",
    x1: 7.506,
    x2: 9.626,
    y1: 27.875,
    y2: 32.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__x",
    x1: 7.506,
    x2: 9.626,
    y1: 27.875,
    y2: 32.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__y",
    x1: 25.524,
    x2: 28.763,
    y1: 33.653,
    y2: 38.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__z",
    x1: 25.524,
    x2: 28.763,
    y1: 33.653,
    y2: 38.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__A",
    x1: 5.05,
    x2: 7.794,
    y1: 18.938,
    y2: 23.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__B",
    x1: 5.05,
    x2: 7.794,
    y1: 18.938,
    y2: 23.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__C",
    x1: 30.138,
    x2: 33.056,
    y1: 31.445,
    y2: 35.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__D",
    x1: 30.138,
    x2: 33.056,
    y1: 31.445,
    y2: 35.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__E",
    x1: 32.732,
    x2: 35.226,
    y1: 27.643,
    y2: 31.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__F",
    x1: 32.732,
    x2: 35.226,
    y1: 27.643,
    y2: 31.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__G",
    x1: 5.428,
    x2: 7.403,
    y1: 17.404,
    y2: 19.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__H",
    x1: 5.428,
    x2: 7.403,
    y1: 17.404,
    y2: 19.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__I",
    x1: 4.229,
    x2: 5.956,
    y1: 18.969,
    y2: 20.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__J",
    x1: 4.229,
    x2: 5.956,
    y1: 18.969,
    y2: 20.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__L",
    x1: 19.862,
    x2: 24.953,
    y1: 18.186,
    y2: 25.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__M",
    x1: 19.862,
    x2: 24.953,
    y1: 18.186,
    y2: 25.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__N",
    x1: 27.058,
    x2: 32.42,
    y1: 18.139,
    y2: 23.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__O",
    x1: 27.058,
    x2: 32.42,
    y1: 18.139,
    y2: 23.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__P",
    x1: 13.049,
    x2: 18.295,
    y1: 18.186,
    y2: 23.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__Q",
    x1: 13.049,
    x2: 18.295,
    y1: 18.186,
    y2: 23.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__R",
    x1: 10.862,
    x2: 38.862,
    y1: 0.498,
    y2: 42.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KoscherSertified_svg__S",
    x1: 10.862,
    x2: 38.862,
    y1: 0.498,
    y2: 42.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })))));
};
export default SvgKoscherSertified;